import { LazyLoadWithCircularProgress } from '../../core/lazyLoad'

import { EDITOR } from '@eig-builder/core-utils/analytics/page-types'
import { STORE } from '@eig-builder/core-utils/analytics/flow-types'

const Routes = [{
  path: '/global-variant/detail/:id?',
  component: LazyLoadWithCircularProgress(() => import('./containers/global-variant-detail')),
  pathToLeaveFocusView: '/global-variants',
  pageType: EDITOR,
  flowType: STORE
},
{
  path: '/global-variants',
  component: LazyLoadWithCircularProgress(() => import('./containers/base')),
  pageType: EDITOR,
  flowType: STORE
}]

export default Routes
